import { defineAsyncComponent, type App, type Component } from 'vue'

export { configureCFormComponents } from './CForm/registry'
export { useColumnSettings } from './CTable/hooks/useColumnSettings'
export { defaultTableRequestAdapter, defaultTableResponseAdapter, useTable } from './CTable/hooks/useTable'
export { RICH_TEXT_SCHEMA_VERSION } from './RichTextEditor/interface'
export type { EchartsEventHandler, EchartsEventMap, EchartsProps } from './Echarts/interface'
export type { FormComponentRegistry, FormCompType, FormItemContext, FormItemProps } from './CForm/interface'
export type {
  RichTextDocument,
  RichTextEditorProps,
  RichTextMediaUploadResult,
  RichTextUploadHandler
} from './RichTextEditor/interface'
export type {
  ColumnLayoutState,
  ColumnProps,
  PageResponse,
  Pageable,
  TableQueryContext,
  TableRequest,
  TableRequestAdapter,
  TableResponseAdapter
} from './CTable/interface'

const components: Record<string, Component> = {
  CAddEditDrawer: defineAsyncComponent(() => import('./CAddEditDrawer/index.vue')),
  CDateTimeRangePicker: defineAsyncComponent(() => import('./CDateTimeRangePicker/index.vue')),
  CDetailDrawer: defineAsyncComponent(() => import('./CDetailDrawer/index.vue')),
  CForm: defineAsyncComponent(() => import('./CForm/index.vue')),
  CFormDrawer: defineAsyncComponent(() => import('./CForm/CFormDrawer.vue')),
  CFormPage: defineAsyncComponent(() => import('./CForm/CFormPage.vue')),
  CSearch: defineAsyncComponent(() => import('./CSearch/index.vue')),
  CTable: defineAsyncComponent(() => import('./CTable/index.vue')),
  CText: defineAsyncComponent(() => import('./CText/index.vue')),
  CardDescriptions: defineAsyncComponent(() => import('./CardDescriptions/index.vue')),
  DictCheckbox: defineAsyncComponent(() => import('./DictCheckbox/index.vue')),
  DictRadio: defineAsyncComponent(() => import('./DictRadio/index.vue')),
  DictSelect: defineAsyncComponent(() => import('./DictSelect/index.vue')),
  DictTag: defineAsyncComponent(() => import('./DictTag/index.vue')),
  DictText: defineAsyncComponent(() => import('./DictText/index.vue')),
  Echarts: defineAsyncComponent(() => import('./Echarts/index.vue')),
  RichTextEditor: defineAsyncComponent(() => import('./RichTextEditor/index.vue')),
  UploadImg: defineAsyncComponent(() => import('./UploadImg/index.vue'))
}

const CommonComponents = {
  install(app: App) {
    Object.entries(components).forEach(([name, component]) => app.component(name, component))
  }
}

export default CommonComponents
